<template>
  <b-modal
    id="funnelReportModal"
    :title="modalTitle"
    size="xl"
    hide-footer
    no-scroll
    no-body-scroll
  >
    <b-card>
      <b-row v-if="funnelReportData && funnelReportData.length > 0">
        <b-col class="text-right">
          <feather-icon
            v-b-tooltip.hover.v-primary
            icon="FileTextIcon"
            class="text-primary font-medium-4 cursor-pointer mr-3 mb-1"
            title="Export"
            @click="exportToExcel()"
          />
        </b-col>
      </b-row>
      <b-table-simple
        hover
        caption-top
        responsive
        class="rounded-bottom mb-0 table table-bordered sticky-header"
      >
        <b-thead head-variant="light" class="sticky-top">
          <b-tr>
            <b-th>Vendor Name</b-th>
            <b-th>Vendor Code</b-th>
            <b-th>Lead Code</b-th>
            <b-th>L1 Service</b-th>
            <b-th>L2 Service</b-th>
            <b-th>Generated by</b-th>
            <b-th v-for="(item, index) in funnelReportStatus" :key="index">
              {{ item.value }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-if="!funnelReportData || funnelReportData.length === 0">
            <b-td
              :colspan="6 + funnelReportStatus.length"
              class="text-center text-muted py-4"
            >
              <feather-icon icon="SearchIcon" size="48" class="mb-2" />
              <div class="h5">
                No data found
              </div>
              <div class="text-sm">
                There are no records to display for the selected criteria.
              </div>
            </b-td>
          </b-tr>
          <b-tr v-for="(item, index) in funnelReportData" v-else :key="index">
            <b-td class="text-left" style="min-width: 150px;">
              {{ item.vendor_name || '' }}
            </b-td>
            <b-td style="min-width: 150px;">
              {{ item.vendor_code || '' }}
            </b-td>
            <b-td style="min-width: 150px;">
              <a
                v-if="item.record_type == 4"
                :href="'/opportunity/' + item.record_id"
                target="_blank"
                rel="noopener noreferrer"
                class="text-info font-weight-bold"
              >
                {{ item.lead_code }}
              </a>
              <a
                v-else
                :href="'/lead/' + item.record_id"
                target="_blank"
                rel="noopener noreferrer"
                class="text-info font-weight-bold"
              >
                {{ item.lead_code }}
              </a>
            </b-td>
            <b-td style="min-width: 150px;">
              {{ item.l1_service_name || '' }}
            </b-td>
            <b-td style="min-width: 150px;">
              {{ item.l2_service_name || '' }}
            </b-td>
            <b-td style="min-width: 250px;">
              {{ item.lead_owner_name || '' }}
            </b-td>
            <b-td
              v-for="(status, sIndex) in funnelReportStatus"
              :key="sIndex"
              style="min-width: 250px;"
            >
              {{ getStatusDate(item, status.key) }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-card>
  </b-modal>
</template>

<script>
import { useUtils } from '@core/libs/i18n'
import excel from '@/excel'
import { dFormat } from '@/utils/common'

export default {
  name: 'FunnelReportModal',
  components: {},
  props: {
    funnelReportData: {
      type: Array,
      default: () => [],
    },
    funnelReportStatus: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      openModal: false,
      modalTitle: 'Funnel Detail Report',
      modalData: [],
      excelData: [],
    }
  },
  watch: {
    funnelReportData: {
      handler(val) {
        this.modalData = val
        this.openModal = true
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', componentId => {
      if (componentId === 'funnelReportModal') {
        this.openModal = false
      }
    })
  },
  methods: {
    getStatusDate(item, key) {
      return item.status[key]
        ? dFormat(item.status[key], 'DD MMMM YYYY hh:mm A')
        : ''
    },
    exportToExcel() {
      this.excelData = []
      this.modalData.forEach(element => {
        const row = {}
        this.funnelReportStatus.forEach(({ key, value: label }) => {
          row[label] = element.status?.[key]
            ? dFormat(element.status?.[key], 'DD MMMM YYYY hh:mm A')
            : ''
        })
        this.excelData.push({
          'Vendor Name': element.vendor_name || '',
          'Vendor Code': element.vendor_code || '',
          'Lead Code': element.lead_code || '',
          'L1 Service': element.l1_service_name || '',
          'L2 Service': element.l2_service_name || '',
          'Generated by': element.lead_owner_name || '',
          ...row,
        })
      })
      excel.methods.exportToExcelJson(this.excelData, 'Funnel Detail')
    },
  },
}
</script>

<style scoped>
.sticky-header {
  max-height: 68vh;
  overflow-y: auto;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f8f9fa;
}

/* Disable modal scroll */
:deep(.modal-body) {
  max-height: 70vh;
  overflow: hidden;
}

:deep(.modal-dialog) {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

:deep(.modal-content) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

:deep(.card-body) {
  overflow: hidden;
  flex: 1;
}
</style>
